"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Enter = function Enter(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 31 31'
  }, props), /*#__PURE__*/_react["default"].createElement('g', {
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(-1041.000000, -400.000000)',
    fill: 'currentColor',
    fillRule: 'nonzero'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(331.000000, 319.000000)'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(710.000000, 81.000000)'
  }, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M28.9198996,0 L13.8896422,0 C12.742624,0 11.8095417,0.933082235 11.8095417,2.08010044 L11.8095417,11.8095417 L2.08010044,11.8095417 C0.933082235,11.8095417 0,12.742624 0,13.8896422 L0,28.9198996 C0,30.0669178 0.933082235,31 2.08010044,31 L28.9198996,31 C30.0669178,31 31,30.0669178 31,28.9198996 L31,2.08010044 C31,0.933082235 30.0669178,0 28.9198996,0 Z M28.9870684,28.9198996 C28.9870684,28.9569366 28.9570621,28.9869429 28.9200251,28.9869429 L2.08010044,28.9869429 C2.0430634,28.9869429 2.01305712,28.9569366 2.01305712,28.9198996 L2.01305712,13.8896422 C2.01305712,13.8526051 2.0430634,13.8225989 2.08010044,13.8225989 L12.8159448,13.8225989 C13.3717514,13.8225989 13.8224733,13.3720025 13.8224733,12.8160703 L13.8224733,2.08022599 C13.8224733,2.04318895 13.8524796,2.01318267 13.8895166,2.01318267 L28.919774,2.01318267 C28.956811,2.01318267 28.9868173,2.04318895 28.9868173,2.08022599 L28.9868173,28.9198996 L28.9870684,28.9198996 Z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M21.0592237,10.7307692 C20.5078678,10.7307692 20.0607551,11.1777452 20.0607551,11.7292106 L20.0607551,20.3155328 L12.6419228,20.3155328 L13.0932699,20.0146429 C13.5520898,19.7088959 13.6761355,19.0889331 13.3701311,18.6301258 C13.0641267,18.1713185 12.4442716,18.0474007 11.9857009,18.3532722 L8.79077564,20.4831643 C8.5130427,20.6683561 8.34615385,20.9799565 8.34615385,21.3138496 C8.34615385,21.6477428 8.51291816,21.9594677 8.79077564,22.144535 L11.9857009,24.2744271 C12.1559524,24.388008 12.3483728,24.4423077 12.5385513,24.4423077 C12.8611201,24.4423077 13.1778353,24.2861339 13.3701311,23.9975735 C13.676011,23.5388907 13.5520898,22.918928 13.0932699,22.6130564 L12.6419228,22.3121665 L21.0592237,22.3121665 C21.6105796,22.3121665 22.0576923,21.8651906 22.0576923,21.3137251 L22.0576923,11.7290861 C22.0576923,11.1777452 21.6105796,10.7307692 21.0592237,10.7307692 Z'
  }))))));
};
/* eslint-enable */
var _default = Enter;
exports["default"] = _default;